(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildMoneyFormatter(format) {
    var fmt = (format || '${{amount}}').replace(/<[^>]+>/g, '').trim() || '${{amount}}';
    function group(amount, precision, thousands, decimal) {
      var n = (amount / 100).toFixed(precision);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
    }
    return function (cents) {
      var c = Math.round(Number(cents) || 0);
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
        switch (name) {
          case 'amount': return group(c, 2, ',', '.');
          case 'amount_no_decimals': return group(c, 0, ',', '.');
          case 'amount_with_comma_separator': return group(c, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return group(c, 0, '.', ',');
          case 'amount_with_space_separator': return group(c, 2, ' ', '.');
          case 'amount_no_decimals_with_space_separator': return group(c, 0, ' ', '.');
          case 'amount_with_apostrophe_separator': return group(c, 2, "'", '.');
          default: return group(c, 2, ',', '.');
        }
      });
    };
  }

  function extractLimit(raw) {
    if (raw == null) return 3;
    var n = parseInt(String(raw).replace(/[^0-9]/g, ''), 10);
    return (isNaN(n) || n <= 0) ? 3 : n;
  }

  function init(root) {
    if (!root || root.__bbInit) return;
    root.__bbInit = true;

    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var variantsContainer = q('[data-bundle-variants]');
    var slotsRow = q('[data-slots-row]');
    var sidebarProducts = q('[data-sidebar-products]');
    var productsGrid = q('[data-bundle-products]');
    var statusEl = q('[data-bundle-status]');
    var form = q('[data-bundle-form]');
    var submitBtn = q('[data-bundle-submit]');
    var variantIdInput = q('[data-variant-id-input]');
    var sellingPlanInput = q('[data-selling-plan-input]');
    var productsInput = q('[data-products-input]');
    var boxSizeInput = q('[data-box-size-input]');
    var purchaseTypeInput = q('[data-purchase-type-input]');
    var deliveryFreqInput = q('[data-delivery-frequency-input]');
    var comparePriceEl = q('[data-bundle-compare-price]');
    var currentPriceEl = q('[data-bundle-current-price]');
    var ancientWidget = q('[data-ancient-widget]');
    var freqSelect = q('[data-ancient-frequency]');
    var subPriceEl = q('[data-bundle-sub-price]');
    var subCompareEl = q('[data-bundle-sub-compare]');
    var onetimePriceEl = q('[data-bundle-onetime-price]');
    var pillsRow = q('[data-bundle-pills]');

    if (!variantsContainer || !slotsRow || !sidebarProducts || !form) return;

    var moneyFormatEl = q('[data-money-format]');
    var formatMoney = buildMoneyFormatter(moneyFormatEl ? moneyFormatEl.textContent.trim() : '${{amount}}');

    var categoryData = {};
    var island = q('[data-bundle-category-data]');
    if (island) {
      try { categoryData = JSON.parse(island.textContent); }
      catch (e) { categoryData = {}; }
    }

    var addedCount = 0;
    var limitCount = 3;
    var currentCategory = '1';
    var isSubscribeMode = false;
    var sellingPlansMap = new Map();
    var subscribeEnabled = root.getAttribute('data-subscribe-enabled') === 'true';

    var variantEls = qa('.bundle-variant');
    var productCards = qa('.bundle-product');
    var slots = qa('.bundle-slot');

    function parseSellingPlans() {
      sellingPlansMap.clear();
      var cat = categoryData[currentCategory] || {};
      var groups = cat.sellingPlanGroups || [];
      groups.forEach(function (g) {
        (g.sellingPlans || []).forEach(function (p) {
          var m = /(\d+)\s*week/i.exec(p.name || '');
          var weeks = m ? parseInt(m[1], 10) : null;
          var adj = (p.priceAdjustments || [])[0];
          var discountPercent = 0;
          if (adj && adj.valueType === 'percentage') discountPercent = Number(adj.value) || 0;
          var data = { id: p.id, name: p.name, discountPercent: discountPercent, weeks: weeks };
          if (weeks != null) sellingPlansMap.set(String(weeks), data);
          if (!sellingPlansMap.has('default')) sellingPlansMap.set('default', data);
        });
      });
    }

    function getSellingPlanData(freq) {
      return sellingPlansMap.get(String(freq)) ||
        sellingPlansMap.get('default') ||
        { id: '', name: '', discountPercent: 15 };
    }

    function populateFrequencySelect() {
      if (!freqSelect) return;
      freqSelect.innerHTML = '';
      var any = false;
      sellingPlansMap.forEach(function (data, key) {
        if (key === 'default') return;
        var opt = document.createElement('option');
        opt.value = key;
        opt.textContent = 'Every ' + key + ' weeks';
        freqSelect.appendChild(opt);
        any = true;
      });
      if (!any) {
        var opt = document.createElement('option');
        opt.value = '';
        opt.textContent = 'Standard delivery';
        freqSelect.appendChild(opt);
      }
    }

    function currentFrequency() {
      return (freqSelect && freqSelect.value) ? freqSelect.value : 'default';
    }

    function getActiveAncient() {
      if (!ancientWidget) return 'onetime';
      var active = ancientWidget.querySelector('.bundle-ancient-option.is-active, .bundle-ancient-option.active');
      return active ? (active.getAttribute('data-ancient-type') || 'onetime') : 'onetime';
    }

    function updateSellingPlan() {
      isSubscribeMode = subscribeEnabled && getActiveAncient() === 'subscribe';
      var discount = 0;
      if (isSubscribeMode) {
        var freq = currentFrequency();
        var plan = getSellingPlanData(freq);
        if (sellingPlanInput) sellingPlanInput.value = plan.id || '';
        if (purchaseTypeInput) purchaseTypeInput.value = 'Subscription';
        if (deliveryFreqInput) {
          deliveryFreqInput.value = (freq && freq !== 'default')
            ? 'Every ' + freq + ' weeks'
            : (plan.name || '');
        }
        discount = plan.discountPercent || 0;
      } else {
        if (sellingPlanInput) sellingPlanInput.value = '';
        if (purchaseTypeInput) purchaseTypeInput.value = 'One-time';
        if (deliveryFreqInput) deliveryFreqInput.value = '';
      }
      updateVariantPrices(isSubscribeMode, discount);
      updatePriceDisplay();
    }

    function updateVariantPrices(isSub, discount) {
      variantEls.forEach(function (el) {
        var orig = parseInt(el.getAttribute('data-original-price'), 10) || 0;
        var eff = orig;
        if (isSub && discount > 0) eff = Math.round(orig * (1 - discount / 100));
        var priceEl = el.querySelector('.bundle-variant-price');
        if (priceEl) priceEl.textContent = formatMoney(eff);
      });
    }

    function activeVariant() {
      var a = variantEls.filter(function (v) { return v.classList.contains('active'); })[0];
      return a || variantEls[0] || null;
    }

    function pickedTotals() {
      var total = 0;
      var minUnit = 0;
      var units = 0;
      sidebarProducts.querySelectorAll('.bundle-sidebar-product').forEach(function (row) {
        var price = parseInt(row.getAttribute('data-price'), 10) || 0;
        var qty = countOf(row);
        if (price <= 0 || qty <= 0) return;
        total += price * qty;
        units += qty;
        if (minUnit === 0 || price < minUnit) minUnit = price;
      });
      return { total: total, minUnit: minUnit, units: units };
    }

    function updatePriceDisplay() {
      if ((root.getAttribute('data-cart-mode') || 'wrapper') === 'individual') {
        var t = pickedTotals();
        var boxFull = limitCount > 0 && addedCount === limitCount;
        var current = t.total;
        var compare = 0;
        if (boxFull && t.units >= 2 && t.minUnit > 0) {
          current = t.total - t.minUnit;
          compare = t.total;
        }
        if (currentPriceEl) currentPriceEl.textContent = formatMoney(current);
        if (comparePriceEl) {
          if (compare > current) {
            comparePriceEl.textContent = formatMoney(compare);
            comparePriceEl.hidden = false;
          } else {
            comparePriceEl.hidden = true;
          }
        }
        if (onetimePriceEl) onetimePriceEl.textContent = formatMoney(current);
        return;
      }
      var v = activeVariant();
      if (!v) return;
      var orig = parseInt(v.getAttribute('data-original-price'), 10) || 0;
      var compareAt = parseInt(v.getAttribute('data-compare-at-price'), 10) || orig;
      var current = orig;
      var compare = compareAt;
      var subDiscount = getSellingPlanData(currentFrequency()).discountPercent || 0;
      var subPrice = subDiscount > 0 ? Math.round(orig * (1 - subDiscount / 100)) : orig;
      if (isSubscribeMode && subDiscount > 0) {
        current = subPrice;
        if (compareAt <= orig) compare = orig;
      }
      if (currentPriceEl) currentPriceEl.textContent = formatMoney(current);
      if (comparePriceEl) {
        if (compare > current) {
          comparePriceEl.textContent = formatMoney(compare);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }
      if (onetimePriceEl) onetimePriceEl.textContent = formatMoney(orig);
      if (subPriceEl) subPriceEl.textContent = formatMoney(subPrice);
      if (subCompareEl) {
        if (subDiscount > 0 && subPrice < orig) {
          subCompareEl.textContent = formatMoney(orig);
        } else {
          subCompareEl.textContent = '';
        }
      }
    }

    function buildSlots(limit) {
      slots.forEach(function (slot, i) {
        slot.classList.toggle('is-slot-hidden', i >= limit);
      });
      slotsRow.classList.toggle('slots-compact', limit >= 5);
    }

    function syncSlots() {
      var items = [];
      sidebarProducts.querySelectorAll('.bundle-sidebar-product').forEach(function (row) {
        var cnt = countOf(row);
        var img = row.querySelector('img');
        var src = img ? img.getAttribute('src') : '';
        for (var i = 0; i < cnt; i++) {
          items.push({ src: src, id: row.getAttribute('data-product-id') });
        }
      });
      slots.forEach(function (slot, i) {
        var slotImg = slot.querySelector('.bundle-slot-img');
        if (i < items.length) {
          slot.classList.add('is-filled');
          if (slotImg) slotImg.src = items[i].src || '';
          slot.setAttribute('data-product-id', items[i].id);
        } else {
          slot.classList.remove('is-filled');
          slot.removeAttribute('data-product-id');
        }
      });
    }

    function getRow(productId) {
      return sidebarProducts.querySelector(
        '.bundle-sidebar-product[data-product-id="' + productId + '"]');
    }
    function countOf(row) {
      var c = row && row.querySelector('.count');
      return c ? (parseInt(c.textContent, 10) || 0) : 0;
    }
    function totalAdded() {
      var n = 0;
      sidebarProducts.querySelectorAll('.bundle-sidebar-product').forEach(function (r) {
        n += countOf(r);
      });
      return n;
    }
    function buildHiddenRow(card) {
      var row = document.createElement('div');
      row.className = 'bundle-sidebar-product';
      row.setAttribute('data-product-id', card.getAttribute('data-id'));
      row.setAttribute('data-variant-id', card.getAttribute('data-variant-id') || '');
      row.setAttribute('data-price', card.getAttribute('data-price') || '0');
      row.setAttribute('data-title', card.getAttribute('data-title'));
      var img = card.querySelector('.bundle-product-image img');
      var src = img ? img.getAttribute('src') : '';
      row.innerHTML =
        '<img src="' + esc(src) + '" alt="">' +
        '<span class="title">' + esc(card.getAttribute('data-title')) + '</span>' +
        '<span class="count">1</span>' +
        '<button type="button" class="trash" data-sidebar-trash aria-label="Remove">&times;</button>';
      return row;
    }

    function cardById(id) {
      return productCards.filter(function (c) {
        return c.getAttribute('data-id') === String(id);
      })[0];
    }

    function updateBundleInputProperty() {
      var parts = [];
      sidebarProducts.querySelectorAll('.bundle-sidebar-product').forEach(function (row) {
        parts.push(row.getAttribute('data-title') + ' (x' + countOf(row) + ')');
      });
      if (productsInput) productsInput.value = parts.join(', ');
    }

    function updateStatus() {
      if (statusEl) statusEl.textContent = addedCount + '/' + limitCount + ' items added';
    }

    function refreshButtons() {
      var full = limitCount > 0 && addedCount === limitCount;
      if (submitBtn) submitBtn.disabled = !full;
      productCards.forEach(function (card) {
        var addBtn = card.querySelector('.bundle-product-button');
        var plus = card.querySelector('[data-qty-plus]');
        if (addBtn) addBtn.disabled = full;
        if (plus) plus.disabled = full;
      });
    }

    function afterMutation() {
      updateBundleInputProperty();
      updateStatus();
      syncSlots();
      refreshButtons();
      updatePriceDisplay();
    }

    function syncCardQty(card) {
      if (!card) return;
      var row = getRow(card.getAttribute('data-id'));
      var val = card.querySelector('[data-qty-value]');
      if (val) val.textContent = row ? countOf(row) : 1;
    }
    function resetCard(card) {
      card.classList.remove('active');
      var val = card.querySelector('[data-qty-value]');
      if (val) val.textContent = '1';
      var btn = card.querySelector('.bundle-product-button');
      if (btn) btn.textContent = btn.getAttribute('data-add-text') || 'Add to box';
    }

    function addOne(card) {
      if (!card || addedCount >= limitCount) return;
      var row = getRow(card.getAttribute('data-id'));
      if (row) {
        var c = row.querySelector('.count');
        c.textContent = countOf(row) + 1;
      } else {
        sidebarProducts.appendChild(buildHiddenRow(card));
      }
      card.classList.add('active');
      var btn = card.querySelector('.bundle-product-button');
      if (btn) btn.textContent = btn.getAttribute('data-added-text') || 'Added';
      syncCardQty(card);
      addedCount = totalAdded();
      afterMutation();
    }

    function removeOne(productId) {
      var row = getRow(productId);
      if (!row) return;
      var newCount = countOf(row) - 1;
      var card = cardById(productId);
      if (newCount <= 0) {
        row.remove();
        if (card) resetCard(card);
      } else {
        row.querySelector('.count').textContent = newCount;
        if (card) syncCardQty(card);
      }
      addedCount = totalAdded();
      afterMutation();
    }

    function selectVariant(el) {
      if (!el) return;
      variantEls.forEach(function (v) { v.classList.remove('active'); });
      el.classList.add('active');
      limitCount = extractLimit(el.getAttribute('data-limit') || el.getAttribute('data-variant-title'));
      if (variantIdInput) variantIdInput.value = el.getAttribute('data-id');
      if (boxSizeInput) boxSizeInput.value = el.getAttribute('data-variant-title') || '';
      sidebarProducts.querySelectorAll('.bundle-sidebar-product').forEach(function (r) { r.remove(); });
      addedCount = 0;
      productCards.forEach(resetCard);
      buildSlots(limitCount);
      updateSellingPlan();
      afterMutation();
    }

    function buildVariantCard(v, active) {
      var cap = v.compareAtPrice || v.price;
      var save = 0;
      if (cap > v.price) save = Math.round((cap - v.price) * 100 / cap);
      var el = document.createElement('button');
      el.type = 'button';
      el.className = 'bundle-variant' + (active ? ' active' : '');
      el.setAttribute('data-limit', extractLimit(v.title));
      el.setAttribute('data-id', v.id);
      el.setAttribute('data-original-price', v.price);
      el.setAttribute('data-compare-at-price', cap);
      el.setAttribute('data-variant-title', v.title);
      el.innerHTML =
        '<span class="bundle-variant-title">' + esc(v.title) + '</span>' +
        '<span class="bundle-variant-price" data-variant-price>' + formatMoney(v.price) + '</span>' +
        '<span class="bundle-variant-save" data-original-save>' +
        (save > 0 ? 'Save ' + save + '%' : '') + '</span>';
      return el;
    }

    function switchCategory(index) {
      var data = categoryData[String(index)];
      if (!data || !data.variants || !data.variants.length) return;
      currentCategory = String(index);
      variantsContainer.innerHTML = '';
      data.variants.forEach(function (v, i) {
        variantsContainer.appendChild(buildVariantCard(v, i === 0));
      });
      variantEls = Array.prototype.slice.call(
        variantsContainer.querySelectorAll('.bundle-variant'));
      wireVariantCards();              /* re-bind: innerHTML wiped the old listeners */
      parseSellingPlans();
      populateFrequencySelect();
      selectVariant(variantEls[0]);
    }

    var productsContainer = q('[data-bundle-products]');
    var displayMode = productsContainer ? productsContainer.getAttribute('data-display-mode') : 'filter';

    function filterByCategory(index) {
      if (displayMode === 'sections') return;
      productCards.forEach(function (card) {
        card.classList.toggle('is-cat-hidden',
          card.getAttribute('data-category') !== String(index));
      });
      qa('[data-category-heading]').forEach(function (header) {
        header.classList.toggle('is-cat-hidden',
          header.getAttribute('data-category') !== String(index));
      });
    }

    function tapFeedback(el) {
      el.classList.add('is-clicked');
      setTimeout(function () { el.classList.remove('is-clicked'); }, 200);
    }

    function bindTap(el, handler) {
      el.addEventListener('touchend', function (e) {
        e.preventDefault();
        handler(e);
      }, { passive: false });
      el.addEventListener('click', function (e) {
        handler(e);
      });
    }

    function wireVariantCards() {
      variantEls.forEach(function (el) {
        el.addEventListener('click', function () { selectVariant(el); });
      });
    }

    function wireProductCards() {
      productCards.forEach(function (card) {
        var addBtn = card.querySelector('.bundle-product-button');
        var plus = card.querySelector('[data-qty-plus]');
        var minus = card.querySelector('[data-qty-minus]');
        if (addBtn) {
          bindTap(addBtn, function () {
            if (addBtn.disabled) return;
            tapFeedback(addBtn);
            addOne(card);
          });
        }
        if (plus) {
          bindTap(plus, function () {
            if (plus.disabled) return;
            addOne(card);
          });
        }
        if (minus) {
          bindTap(minus, function () {
            removeOne(card.getAttribute('data-id'));
          });
        }
      });
    }

    function wireSlotRemoval() {
      slotsRow.addEventListener('click', function (e) {
        var btn = e.target.closest('.bundle-slot-remove');
        if (!btn) return;
        var slot = btn.closest('.bundle-slot');
        if (slot && slot.getAttribute('data-product-id')) {
          removeOne(slot.getAttribute('data-product-id'));
        }
      });
    }

    function wireSidebarTrash() {
      sidebarProducts.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-sidebar-trash]');
        if (!btn) return;
        var row = btn.closest('.bundle-sidebar-product');
        if (row) removeOne(row.getAttribute('data-product-id'));
      });
    }

    function wireAncient() {
      if (!ancientWidget) return;
      ancientWidget.querySelectorAll('.bundle-ancient-option').forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          if (e.target.closest('.bundle-ancient-freq') || e.target.closest('select')) return;
          ancientWidget.querySelectorAll('.bundle-ancient-option').forEach(function (o) {
            o.classList.remove('active');
            o.classList.remove('is-active');
            var r = o.querySelector('[data-ae-purchase-radio]');
            if (r) r.checked = false;
          });
          opt.classList.add('active');
          opt.classList.add('is-active');
          var radio = opt.querySelector('[data-ae-purchase-radio]');
          if (radio) radio.checked = true;
          updateSellingPlan();
        });
      });
      if (freqSelect) {
        freqSelect.addEventListener('change', updateSellingPlan);
      }
    }

    function wirePills() {
      if (!pillsRow) return;
      var pills = Array.prototype.slice.call(
        pillsRow.querySelectorAll('.collection-category-pills__pill'));
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var idx = pill.getAttribute('data-filter-category');
          pills.forEach(function (p) {
            p.classList.remove('collection-category-pills__pill--active');
          });
          pill.classList.add('collection-category-pills__pill--active');
          filterByCategory(idx);
          switchCategory(idx);
        });
      });
    }

    function wireSubmit() {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (submitBtn && submitBtn.disabled) return;
        var origText = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }

        var cartMode = root.getAttribute('data-cart-mode') || 'wrapper';
        var request;
        if (cartMode === 'individual') {
          var items = [];
          sidebarProducts.querySelectorAll('.bundle-sidebar-product').forEach(function (row) {
            var vid = parseInt(row.getAttribute('data-variant-id'), 10);
            var qty = countOf(row);
            if (vid && qty > 0) items.push({ id: vid, quantity: qty });
          });
          if (!items.length) {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origText; }
            return;
          }
          request = fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        } else {
          request = fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: new FormData(form)
          });
        }

        request.then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function () {
          var discountCode = root.getAttribute('data-discount-code');
          if (cartMode === 'individual' && discountCode) {
            fetch('/discount/' + encodeURIComponent(discountCode)).catch(function () {});
          }
          if (submitBtn) submitBtn.textContent = origText;
          if (typeof window.refreshCart === 'function') window.refreshCart();
          document.dispatchEvent(new CustomEvent('ae:cart:updated'));
          var aeDrawer = document.getElementById('site-cart-sidebar');
          var drawer = document.querySelector('cart-drawer, #CartDrawer, [data-cart-drawer]');
          if (aeDrawer && typeof aeDrawer.show === 'function') {
            aeDrawer.show();
          } else if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else if (drawer) {
            drawer.classList.add('is-open', 'active', 'drawer--open');
          } else {
            window.location.href = '/cart';
          }
        }).catch(function () {
          if (submitBtn) { submitBtn.textContent = origText; submitBtn.disabled = false; }
          form.submit();
        });
      });
    }

    parseSellingPlans();
    populateFrequencySelect();
    wireProductCards();
    wireVariantCards();
    wireSlotRemoval();
    wireSidebarTrash();
    wireAncient();
    wirePills();
    wireSubmit();

    var startVariant = activeVariant();
    if (startVariant) {
      limitCount = extractLimit(
        startVariant.getAttribute('data-limit') ||
        startVariant.getAttribute('data-variant-title'));
    }
    updateSellingPlan();
    buildSlots(limitCount);
    afterMutation();
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-ae-bundle-builder]');
    Array.prototype.forEach.call(roots, init);
  }

  ready(function () { boot(document); });

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
